var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3868 2.81767C10.582 3.01924 10.582 3.34603 10.3868 3.54759L6.07364 7.99984L10.3868 12.4521C10.582 12.6536 10.582 12.9804 10.3868 13.182C10.1915 13.3836 9.87491 13.3836 9.67965 13.182L5.01298 8.3648C4.81772 8.16323 4.81772 7.83644 5.01298 7.63488L9.67965 2.81767C9.87491 2.61611 10.1915 2.61611 10.3868 2.81767Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBack);
export default __webpack_public_path__ + "static/media/orange-back.0457171746d2d1ccc86c94904d7c5877.svg";
export { ForwardRef as ReactComponent };